<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
<h2 mat-dialog-title cdkDragHandle>Import Refinery</h2>

<mat-dialog-content>

  <input type="file"
         accept=".dtr,.zip"
         (change)="onFileSelected($event)"
         style="margin-top: 10px;">

  <div *ngIf="error" style="color: red; margin-top: 10px;">
    {{ error }}
  </div>

  <div *ngIf="selectedFile" style="margin-top: 15px;">
    Selected package: {{ selectedFile.name }}
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" (click)="importFile()" [disabled]="!selectedFile">
    Import
  </button>
</mat-dialog-actions>
</div>
